// angular.module('raSpinner', [])
// .factory('raSpinnerService',

export default function SpinnerService() {
    const spinners = {};
    return {
        _register(data) {
            if (!data.hasOwnProperty('name')) {
                throw new Error('Spinner must specify a name when registering with the spinner service.');
            }
            // if (spinners.hasOwnProperty(data.name)) {
            // 	//throw new Error("A spinner with the name '" + data.name + "' has already been registered.");
            // } else {
            // 	spinners[data.name] = data;
            // }
            spinners[data.name] = data;
        },

        _unregister(name) {
            if (spinners.hasOwnProperty(name)) {
                delete spinners[name];
            }
        },

        _unregisterGroup(group) {
            for (const name in spinners) {
                if (spinners[name].group === group) {
                    delete spinners[name];
                }
            }
        },

        unregisterAll() {
            for (const name in spinners) {
                delete spinners[name];
            }
        },

        isRegistered(name) {
            return spinners.hasOwnProperty(name);
        },

        show(name) {
            const spinner = spinners[name];
            if (!spinner) {
                throw new Error(`No spinner named '${name}' is registered.`);
            }
            spinner.show();
        },

        hide(name) {
            const spinner = spinners[name];
            if (!spinner) {
                throw new Error(`No spinner named '${name}' is registered.`);
            }
            spinner.hide();
        },

        showGroup(group) {
            let groupExists = false;
            for (const name in spinners) {
                const spinner = spinners[name];
                if (spinner.group === group) {
                    spinner.show();
                    groupExists = true;
                }
            }
            if (!groupExists) {
                throw new Error(`No spinners found with group '${group}'.`);
            }
        },

        hideGroup(group) {
            let groupExists = false;
            for (const name in spinners) {
                const spinner = spinners[name];
                if (spinner.group === group) {
                    spinner.hide();
                    groupExists = true;
                }
            }
            if (!groupExists) {
                throw new Error(`No spinners found with group '${group}'.`);
            }
        },

        showAll() {
            for (const name in spinners) {
                spinners[name].show();
            }
        },
        hideAll() {
            for (const name in spinners) {
                spinners[name].hide();
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/spinner/spinnerService.js